// Structural (language-independent) data: icons, colors, images, hrefs.
// All display text lives in translations.js and is resolved per language.
import {
  FileText, Pill, FolderCheck, Radio, Wallet, CalendarClock,
  Lock, Users, History, BookOpen, Download, BarChart3,
  Newspaper, Trophy, BookMarked, HelpCircle,
  ShieldCheck, HeartPulse, Award, Globe, Activity, FileCheck,
} from "lucide-react";

// Nav items keyed to translations.nav. type: anchor | dropdown | route
export const NAV_ITEMS = [
  { key: "brainmart", href: "#top", type: "anchor", label: "Brainmart" },
  { key: "modules", to: "/modulos", type: "route" },
  { key: "resources", type: "dropdown" },
];

// Mega-menu rows for the "Resources" nav dropdown (order matches translations.resourcesMenu.items)
export const RESOURCE_MENU_META = [
  { icon: Newspaper, color: "#38bdf8", href: "/blog" },
  { icon: Trophy, color: "#fbbf24", href: "/casos" },
  { icon: BookMarked, color: "#34d399", href: "/glosario" },
  { icon: HelpCircle, color: "#818cf8", href: "/faq" },
  { icon: History, color: "#f472b6", href: "/changelog" },
];

export const HERO_IMAGE = "/hero-researcher.webp";

export const HERO_STAT = "99.8%";

export const CLIENTS = [
  "CEMIC", "ICBA", "Mautalen", "CIMEL", "NEXO", "Care",
  "Kynetar", "CIMeT", "Ciprec", "Bioimagenes", "Maffei", "Favaloro",
];

// Order matches translations.modules.items ; slug links to /modulos/:slug
export const MODULE_ICONS = [
  { icon: FileText, color: "#38bdf8", slug: "esource" },
  { icon: Pill, color: "#818cf8", slug: "farmacia-laboratorio" },
  { icon: FolderCheck, color: "#34d399", slug: "eisf" },
  { icon: Radio, color: "#a78bfa", slug: "monitoreo-remoto" },
  { icon: Wallet, color: "#fbbf24", slug: "administracion" },
  { icon: CalendarClock, color: "#f87171", slug: "agenda" },
];

// Regional reach section
export const REGIONAL_MAP =
  "https://images.unsplash.com/photo-1516738901171-8eb4fc13bd20?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

// value counters (labels come from translations.regional.stats)
export const STAT_META = [
  { value: 600, prefix: "+" },
  { value: 50, prefix: "+" },
  { value: 7, prefix: "" },
  { value: 50, prefix: "+" },
];

export const COMPLIANCE_BADGES = [
  { icon: ShieldCheck, label: "GCP Compliant" },
  { icon: HeartPulse, label: "HIPAA" },
  { icon: Award, label: "ISO 27001" },
  { icon: Globe, label: "GDPR Ready" },
  { icon: Activity, label: "HL7 / FHIR" },
  { icon: FileCheck, label: "FDA 21 CFR Part 11" },
];

// Cert names are brand-constant; subs come from translations.security.certSubs
export const CERT_NAMES = ["ISO 27001", "FDA 21 CFR", "ICH/GCP", "EMA", "ANMAT"];

// Order matches translations.security.features
export const SECURITY_ICONS = [Lock, Users, History];

// Order matches translations.resources.items ; typeKey maps to tabs/typeColor
export const RESOURCE_META = [
  { typeKey: "case", icon: FileText, image: "https://images.unsplash.com/photo-1581093577421-f561a654a353?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", href: "/casos/ciprec-assessment-metricas" },
];

export const TYPE_COLOR = {
  blog: "#38bdf8",
  case: "#a78bfa",
  download: "#34d399",
};

export const TAB_KEYS = ["all", "blog", "case"];
